import { jobTypesIdEnum } from '../../models-enums';

// Job types that can produce NOT TESTED assets and therefore show the
// "Include NOT TESTED Assets?" toggle on the Final Check modal.
const measurementPointJobTypeIDs: string[] = [
    jobTypesIdEnum.inspection,
    jobTypesIdEnum.verification
];

export function shouldShowNotTestedToggle(jobTypeID?: string): boolean {
    return !!jobTypeID && measurementPointJobTypeIDs.includes(jobTypeID);
}

// MMG-4513: repair jobs can leave the Deficiency / Repair page out of the report (the server decides if it has content)
export function shouldOfferDeficiencyChoice(jobTypeID?: string): boolean {
    return jobTypeID === jobTypesIdEnum.repair;
}

/*
 * What to send for "Include NOT TESTED Assets?" when the FSE hasn't been asked — the
 * report preview in the job actions dropdown, which has no toggle of its own. It has to
 * match the Final Check default (off = excluded) or the preview shows assets the closed
 * job's report will leave out, which is worse than offering no preview at all. Job types
 * without the toggle keep including everything, exactly as they do today.
 */
export function defaultIncludeNotTestedAssets(jobTypeID?: string): boolean {
    return !shouldShowNotTestedToggle(jobTypeID);
}

/*
 * The report preview tab can only be opened once the PDF blob has been fetched, which
 * is outside the original click gesture, so a popup blocker may swallow it. Chrome and
 * Firefox return null; Safari can hand back a window that is already closed. Callers
 * offer the FSE a link to click when this returns true — that click is a fresh gesture
 * and is never blocked.
 */
export function isPopupBlocked(previewWindow: Window | null | undefined): boolean {
    if (!previewWindow) {
        return true;
    }

    return previewWindow.closed;
}
